import { render, staticRenderFns } from "./groupOper.vue?vue&type=template&id=31606263&scoped=true"
import script from "./groupOper.vue?vue&type=script&lang=js"
export * from "./groupOper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31606263",
  null
  
)

export default component.exports